import FeatureGates from "@atlaskit/feature-gate-js-client";
import { EXPERIMENTS, PARAMETERS } from "../../experiment/experiments";

/**
 * Subscribe to Statsig updates for the session replay experiment. Re-invokes when the parameter value changes.
 * Does not fire experiment exposure from the subscription callback (eligibility is re-read in the listener).
 */
export const subscribeSessionReplayExperiment = (onExperimentMaybeChanged: () => void): (() => void) => {
  return FeatureGates.onExperimentValueUpdated(
    EXPERIMENTS.SESSION_REPLAY,
    PARAMETERS.isSessionReplayEnabled,
    false,
    () => {
      onExperimentMaybeChanged();
    },
    { fireExperimentExposure: false },
  );
};
